import BaseEnumType from "../../common/base-enum-type";

const PassType = Object.freeze({
    SHORT_LEFT: new BaseEnumType("SL", "Short Left"),
    SHORT_MIDDLE: new BaseEnumType("SM", "Short Middle"),
    SHORT_RIGHT: new BaseEnumType("SR", "Short Right"),
    DEEP_LEFT: new BaseEnumType("DL", "Deep Left"),
    DEEP_MIDDLE: new BaseEnumType("DM", "Deep Middle"),
    DEEP_RIGHT: new BaseEnumType("DR", "Deep Right"),
    SCREEN_LEFT: new BaseEnumType("SCL", "Screen Left"),
    SCREEN_MIDDLE: new BaseEnumType("SCM", "Screen Middle"),
    SCREEN_RIGHT: new BaseEnumType("SCR", "Screen Right"),
    OUTSIDE_LEFT: new BaseEnumType("OL", "Outside Left"),
    OUTSIDE_RIGHT: new BaseEnumType("OR", "Outside Right"),
    SKIP: new BaseEnumType("SKIP", "Skip")
});

export default PassType;
